import { useState } from "react";
import { CountrySelectorMenu } from "./CountrySelectorMenu";
import "./countrySelector.css";

export const CountrySelector = () => {
  const [open, setOpen] = useState(false);

  const onOpenMenu = () => {
    setOpen(!open);
  };

  return (
    <div className="country-selector">
      <div className="country-selector-button" onClick={onOpenMenu}>
        <a href>CHANGE COUNTRY</a>
      </div>
      {open && (
        <CountrySelectorMenu onOpenMenu={onOpenMenu}/>
      )}
    </div>
  );
};
